import type { TFunction } from "i18next";
import { toast } from "sonner";

const downloadFile = (href: string, name: string) => {
  const link = document.createElement("a");
  link.href = href;
  link.download = name;
  link.rel = "noopener";

  if (/^https?:\/\//i.test(href)) {
    link.target = "_blank";
  }

  document.body.appendChild(link);
  link.click();
  link.remove();
};

const trimToExcelExt = (name: string) => {
  const clean = name.split(/[?#]/)[0] || name;

  const m = clean.match(/^(.*?\.xlsx?)/i);
  return m?.[1] ?? clean;
};

export const getFileDisplayName = (file?: File | string | null) => {
  if (file instanceof File) return trimToExcelExt(file.name);

  if (typeof file === "string") {
    const lastSegment = file.split("/").pop() ?? file;
    return trimToExcelExt(lastSegment);
  }

  return "file";
};

export const handleFileDownload = (fileName: string, t: TFunction, file?: File | string | null) => {
  if (!file) return;
  if (typeof file === "string") {
    downloadFile(file, fileName);
    return;
  }

  if (file instanceof File) {
    const url = URL.createObjectURL(file);
    try {
      downloadFile(url, fileName);
    } catch {
      toast.error(t("errorDownloadingFile"));
    } finally {
      toast.success(t("fileDownloaded"));
      URL.revokeObjectURL(url);
    }
  }
};
